import { formatCurrency } from "@/helpers/currency-helpers";
import { formatVariationsLabel } from "@/helpers/variation-helpers";
import { ISku, ISkuInput, IVariation } from "@/interfaces/sku.interface";

type UseSkuDataReturn = Omit<Partial<ISku>, "kitComponents"> & {
  isActive: boolean;
  formattedPrice: string;
  formattedStock: string;
  formattedVariations: string;
};

type UseSkuDataProps = {
  sku?: ISku | ISkuInput;
  productVariations?: any[];
};

function useSkuData({ sku, productVariations }: UseSkuDataProps): UseSkuDataReturn {
  const isActive = sku?.active || false;
  const mainPrice = Number(sku?.mainPrice) || 0;
  const promoPrice = Number(sku?.promoPrice) || 0;
  const stock = Number(sku?.stock) || 0;

  const today = new Date();
  const startDate = new Date(sku?.startPromoPrice || 0);
  const endDate = new Date(sku?.endPromoPrice || 0);

  // Determinar se o preço promocional deve ser exibido
  const showPromoPrice = promoPrice > 0 && today >= startDate && today <= endDate;

  // Formatar o preço a ser exibido
  const formattedPrice = formatCurrency(showPromoPrice ? promoPrice : mainPrice, "pt-BR", "BRL");

  const formattedStock = stock.toString();

  const formattedVariations = formatVariationsLabel(
    sku?.variations as string | IVariation[] | undefined,
    productVariations
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { kitComponents, ...rest } = sku || {};
  return { ...rest, isActive, formattedPrice, formattedStock, formattedVariations };
}

export default useSkuData;
